var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"page-index"},[_c('el-header',[_c('public-header')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }